export default "__VITE_ASSET__GdvDqmkL__"